import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-detail-c" }

import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { XrkTable, XrkTableProps, XrkTableRef } from 'xrk-components';

import { comprehensiveViewDetails } from '../data-source/apis';
import {
  indexCol,
  fullNameCol,
  phoneCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  comprehensiveServiceRateCol,
  comprehensiveServiceAmountCol,
  payStatusCol
} from '../fields/columns';
import {
  fullNameSearch,
  phoneSearch,
  payStatusSearch
} from '../fields/searchs';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'comprehensive-order-detail',
  setup(__props) {

const route = useRoute();

const detailInfo = computed(() => {
  return {
    id: +route.query.id
  };
});

const xrkTableRef = ref<XrkTableRef>();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    fullNameSearch,
    phoneSearch,
    {
      ...payStatusSearch,
      config: {
        options: ORDER_PAY_STATUS_PAY_SUCCESS
      }
    }
  ],
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    indexCol,
    fullNameCol,
    phoneCol,
    settlementTaskCountCol,
    taskPriceCol,
    projectPayPriceCol,
    comprehensiveServiceRateCol,
    comprehensiveServiceAmountCol,
    {
      ...payStatusCol,
      formatter({ cellValue }) {
        return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
      }
    }
  ]
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    id: detailInfo.value.id
  };
  const data = await comprehensiveViewDetails(reqData);
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      style: {"height":"650px"},
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})